export const getSixLatestMonthsForReportsUI = () => {
  const startYear = 2024;
  const startMonth = 8;

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1; // current month index

  const monthsInRange = [];
  let sixMonths = 6;
  let year = currentYear;
  let month = currentMonth;

  while (sixMonths > 0) {
    if (startYear < year || (startYear == year && startMonth < month)) {
      if (month === 1) {
        monthsInRange.push({ month, year });
        year -= 1;
        month = 12;
      } else {
        monthsInRange.push({ month, year });
        month -= 1;
      }
    }
    sixMonths -= 1;
  }
  return monthsInRange;
};

export const convertNumericMonthToName = (monthNumber: number) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return months[monthNumber - 1];
};

export const convertMonthNameToNumeric = (monthName: string): number | null => {
  const months: Record<string, number> = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12,
  };

  return months[monthName] ?? null;
};

const PENDING_REPORTS_KEY = "pendingReports";

// Save a report to localStorage
export const savePendingReport = (
  account: string,
  year: number,
  reportType: string,
  month: number,
) => {
  const pendingReports = JSON.parse(
    localStorage.getItem(PENDING_REPORTS_KEY) || "[]",
  );

  if (!pendingReports.find((r: any) => r.year === year && r.month === month)) {
    pendingReports.push({ account, year, reportType, month });
    localStorage.setItem(PENDING_REPORTS_KEY, JSON.stringify(pendingReports));
  }
};

// Remove a completed report from localStorage
export const removePendingReport = (year: number, month: number) => {
  let pendingReports = JSON.parse(
    localStorage.getItem(PENDING_REPORTS_KEY) || "[]",
  );
  pendingReports = pendingReports.filter(
    (r: any) => !(r.year === year && r.month === month),
  );
  localStorage.setItem(PENDING_REPORTS_KEY, JSON.stringify(pendingReports));
};

// Get all pending reports
export const getPendingReports = () => {
  return JSON.parse(localStorage.getItem(PENDING_REPORTS_KEY) || "[]");
};
